import { Rest } from "app/rest/rest_client";

export namespace RestExtTaskWork {

  export enum ActionWorkEnum {
    WORK_BO_JORNADA_VIEW = "WORK_BO_JORNADA_VIEW",
    WORK_BO_JORNADA_EXPORT = "WORK_BO_JORNADA_EXPORT",
    WORK_BO_JORNADA_VALIDATE = "WORK_BO_JORNADA_VALIDATE",
    WORK_BO_JORNADA_MANUAL_CREATE = "WORK_BO_JORNADA_MANUAL_CREATE",
    WORK_BO_CORRECTION_PROPOSE = "WORK_BO_CORRECTION_PROPOSE",
    WORK_BO_CORRECTION_VIEW = "WORK_BO_CORRECTION_VIEW",
    WORK_BO_CORRECTION_REVIEW = "WORK_BO_CORRECTION_REVIEW",
    WORK_BO_SENSITIVE_VIEW = "WORK_BO_SENSITIVE_VIEW",
    WORK_BO_REPORT_READ = "WORK_BO_REPORT_READ",
    WORK_BO_REPORT_TEMPLATE_SHARE = "WORK_BO_REPORT_TEMPLATE_SHARE",
    WORK_BO_JORNADA_TYPE_MANAGE = "WORK_BO_JORNADA_TYPE_MANAGE",
    WORK_BO_INSPECTOR_MANAGE = "WORK_BO_INSPECTOR_MANAGE",
    WORK_BO_USER_WORK_MANAGE = "WORK_BO_USER_WORK_MANAGE",

    // Pause Types screen (defined after the initial permission set)
    WORK_BO_PAUSETYPE_VIEW = "WORK_BO_PAUSETYPE_VIEW",
    WORK_BO_PAUSETYPE_UPDATE = "WORK_BO_PAUSETYPE_UPDATE",
    WORK_BO_PAUSETYPE_DELETE = "WORK_BO_PAUSETYPE_DELETE",
  }

  // TODO: as Work screens get built, group their actions here the same way
  // RestExtTask.FormTaskEmum + getActionsByType group Task's screens.

  export function hasPermissionrp(action: RestExtTaskWork.ActionWorkEnum, user: Rest.User): boolean {
    for (let a in user.rolesProfiles) {
      if (user.rolesProfiles[a].profile.actions.some((x) => x.name === action.toString()) === true) {
        return true;
      }
    }
    return false;
  }

  /** True if the user has ANY permission from the Work module (used to decide whether to show/route to Work at all). */
  export function hasAnyPermission(user: Rest.User): boolean {
    return Object.values(ActionWorkEnum).some((action) => hasPermissionrp(action, user));
  }
}
